/**
 * BillingBrandSelector
 *
 * Brand dropdown in the header of billing admin sections.
 * Shows only when admin has multiple brands (hidden for single brand).
 *
 * @see US1, AC-1 in docs/specifications/2026-03-08-billing-admin-ui.md
 */
import React from "react";
import type { Brand } from "../../../types/brand";

interface BillingBrandSelectorProps {
  brands: Brand[];
  selectedBrand: Brand | null;
  onSelectBrand: (brandId: string) => void;
}

const BillingBrandSelector: React.FC<BillingBrandSelectorProps> = ({
  brands,
  selectedBrand,
  onSelectBrand,
}) => {
  // Single brand — auto-selected, no dropdown needed
  if (brands.length <= 1) {
    return null;
  }

  return (
    <div className="flex items-center gap-3">
      <label className="text-sm font-medium text-neutral-700">Marka:</label>
      <select
        value={selectedBrand?.id ?? ""}
        onChange={(e) => onSelectBrand(e.target.value)}
        className="text-sm border border-neutral-300 rounded-md px-3 py-1.5 bg-white focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
      >
        <option value="" disabled>
          Wybierz brand...
        </option>
        {brands.map((brand) => (
          <option key={brand.id} value={brand.id}>
            {brand.displayName}
          </option>
        ))}
      </select>
    </div>
  );
};

export default BillingBrandSelector;
